import { render, staticRenderFns } from "./McqQuestionComponent.vue?vue&type=template&id=d973d67c&scoped=true"
import script from "./McqQuestionComponent.vue?vue&type=script&lang=js"
export * from "./McqQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./McqQuestionComponent.vue?vue&type=style&index=0&id=d973d67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d973d67c",
  null
  
)

export default component.exports